/* src/app/modules_v2/booking/components/booking-calendar/booking-calendar.component.css */
.calendar-wrapper {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
  margin: 2rem auto;
}
.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem 1rem;
  border-bottom: 1px solid #e8e8e8;
}
.calendar-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1f1f1f;
  text-transform: capitalize;
}
.header-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}
.btn-nav {
  background: #f3f4f6;
  border: none;
  color: #222;
  font-weight: 500;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  transition: background 0.2s;
}
.btn-nav:hover {
  background: #e5e7eb;
}
.btn-today {
  background: var(--cf-brand-dark, #4d7a00);
  color: #1a1d23;
  border-radius: 6px;
  border: none;
  padding: 6px 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}
.btn-today:hover {
  background: #d88714;
}
.view-switch {
  display: flex;
  align-items: center;
  background: #1f2937;
  border-radius: 6px;
  overflow: hidden;
}
.view-switch button {
  background: none;
  border: none;
  color: white;
  font-weight: 500;
  padding: 6px 12px;
  cursor: pointer;
  transition: background 0.2s;
}
.view-switch button.active {
  background: var(--cf-brand-dark, #4d7a00);
  color: #1a1d23;
}
.view-switch button:hover {
  background: #374151;
}
.calendar-filters {
  display: flex;
  gap: 12px;
  padding: 12px 0 0;
  flex-wrap: wrap;
}
.filter-item {
  flex: 1 1 220px;
  min-width: 200px;
}
::ng-deep .cal-day-cell {
  border-color: #f0f0f0 !important;
}
::ng-deep .cal-day-number {
  font-weight: 600 !important;
  color: #2e2e2e !important;
}
::ng-deep .cal-header {
  background: #f9fafb !important;
  color: #444;
  font-weight: 600;
  border-radius: 10px 10px 0 0;
}
::ng-deep .cal-day-cell.cal-today {
  background: #fffaf3 !important;
  border: 2px solid var(--cf-brand-dark, #4d7a00) !important;
  border-radius: 10px;
}
.month-events-list {
  padding: 2px 4px 4px;
  min-height: 0;
}
.month-mini-event {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  border: none;
  border-left: 3px solid var(--cf-brand-dark, #4d7a00);
  background: #fff8ee;
  border-radius: 4px;
  padding: 2px 6px;
  margin-bottom: 2px;
  cursor: pointer;
  font-size: 11px;
  text-align: left;
  overflow: hidden;
  transition: background 0.15s;
}
.month-mini-event:hover {
  background: #fff0d0;
}
.month-mini-event-hidden {
  background: #f9f9f9;
  border-left-color: #aaa;
}
.month-mini-event-time {
  color: #888;
  font-size: 10px;
  white-space: nowrap;
  flex-shrink: 0;
}
.month-mini-event-contact {
  color: #222;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.month-more-events {
  width: 100%;
  border: none;
  background: none;
  color: var(--cf-brand-dark, #4d7a00);
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  padding: 2px 4px;
}
.month-more-events:hover {
  text-decoration: underline;
}
.month-hidden-events-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 4px;
  margin-top: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
.booksy-week-view {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  margin-top: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.booksy-week-header {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 2;
}
.booksy-week-employee-corner {
  width: 160px;
  min-width: 160px;
  flex-shrink: 0;
  border-right: 1px solid #e5e7eb;
}
.booksy-week-day-header {
  flex: 1;
  min-width: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 4px;
  border-right: 1px solid #e5e7eb;
  gap: 2px;
}
.booksy-week-day-header:last-child {
  border-right: none;
}
.booksy-week-day-today {
  background: #fff8ee;
}
.booksy-week-day-name {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.booksy-week-day-num {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1;
}
.booksy-day-num-today {
  background: var(--cf-brand-dark, #4d7a00);
  color: #1a1d23;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.booksy-week-body {
  display: flex;
  flex-direction: column;
}
.booksy-week-row {
  display: flex;
  border-bottom: 1px solid #f3f4f6;
  min-height: 72px;
}
.booksy-week-row:last-child {
  border-bottom: none;
}
.booksy-week-employee-cell {
  width: 160px;
  min-width: 160px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-right: 1px solid #e5e7eb;
  background: #f9fafb;
}
.booksy-week-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.booksy-week-avatar-fallback {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--cf-brand-dark, #4d7a00);
  color: #1a1d23;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.booksy-week-employee-name {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.booksy-week-day-cell {
  flex: 1;
  min-width: 110px;
  padding: 4px;
  border-right: 1px solid #f3f4f6;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: relative;
  transition: background 0.15s;
}
.booksy-week-day-cell:last-child {
  border-right: none;
}
.booksy-week-day-cell:hover {
  background: #fffbf0;
}
.booksy-week-day-cell-today {
  background: #fff8ee;
}
.booksy-week-event-card {
  display: flex;
  flex-direction: column;
  gap: 1px;
  width: 100%;
  border: none;
  border-left: 3px solid;
  border-radius: 4px;
  padding: 3px 6px;
  cursor: pointer;
  text-align: left;
  font-size: 11px;
  background: rgba(227, 253, 100, 0.12);
  transition: filter 0.15s;
  overflow: hidden;
}
.booksy-week-event-card:hover {
  filter: brightness(0.92);
}
.booksy-week-event-time {
  color: #6b7280;
  font-size: 10px;
  white-space: nowrap;
}
.booksy-week-event-contact {
  color: #1f2937;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.booksy-week-add-hint {
  color: #d1d5db;
  font-size: 20px;
  font-weight: 300;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
.booksy-week-no-employees {
  padding: 24px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
}
.booksy-day-view {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  margin-top: 12px;
}
.booksy-day-header {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 2;
  overflow-x: auto;
}
.booksy-time-corner {
  width: 76px;
  min-width: 76px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 4px;
  border-right: 1px solid #e5e7eb;
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
}
.booksy-employee-headers {
  display: flex;
  overflow-x: auto;
}
.booksy-empty-header {
  padding: 12px 20px;
  color: #9ca3af;
  font-size: 13px;
  white-space: nowrap;
}
.booksy-employee-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-right: 1px solid #e5e7eb;
  flex-shrink: 0;
}
.booksy-employee-header:last-child {
  border-right: none;
}
.booksy-employee-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.booksy-employee-avatar-fallback {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--cf-brand-dark, #4d7a00);
  color: #1a1d23;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.booksy-employee-text {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.booksy-employee-name {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.booksy-employee-subtitle {
  font-size: 11px;
  color: #9ca3af;
}
.booksy-day-body {
  display: flex;
  overflow: auto;
  flex: 1;
  min-height: 400px;
  max-height: 75vh;
  position: relative;
}
.booksy-time-column {
  width: 76px;
  min-width: 76px;
  flex-shrink: 0;
  position: relative;
  border-right: 1px solid #e5e7eb;
  background: #fafafa;
}
.booksy-time-label {
  position: absolute;
  right: 8px;
  font-size: 11px;
  color: #9ca3af;
  font-weight: 500;
  white-space: nowrap;
  transform: translateY(-50%);
  -webkit-user-select: none;
  user-select: none;
}
.booksy-columns-wrapper {
  display: flex;
  position: relative;
  flex: 1;
}
.booksy-grid-lines {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 0;
}
.booksy-grid-line {
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background: #e5e7eb;
}
.booksy-grid-line-half {
  background: #f3f4f6;
}
.booksy-current-time-line {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background: #ef4444;
  z-index: 3;
  pointer-events: none;
}
.booksy-current-time-dot {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ef4444;
  position: absolute;
  left: -5px;
  top: -4px;
}
.booksy-employee-column {
  position: relative;
  border-right: 1px solid #e5e7eb;
  flex-shrink: 0;
  cursor: pointer;
  background: transparent;
  transition: background 0.15s;
}
.booksy-employee-column:last-child {
  border-right: none;
}
.booksy-employee-column:hover {
  background: rgba(227, 253, 100, 0.03);
}
.booksy-day-event {
  position: absolute;
  left: 4px;
  right: 4px;
  border: none;
  border-left: 3px solid;
  border-radius: 5px;
  padding: 4px 6px;
  cursor: pointer;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 1px;
  overflow: hidden;
  z-index: 1;
  transition: filter 0.15s, box-shadow 0.15s;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.booksy-day-event:hover {
  filter: brightness(0.92);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
}
.booksy-day-event-time {
  font-size: 10px;
  color: #374151;
  font-weight: 600;
  white-space: nowrap;
}
.booksy-day-event-contact {
  font-size: 12px;
  font-weight: 700;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.booksy-day-event-title {
  font-size: 11px;
  color: #4b5563;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.booksy-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-size: 14px;
  width: 100%;
  text-align: center;
}
.cal-cell-top {
  padding: 4px 6px 2px;
  display: flex;
  justify-content: flex-end;
}
::ng-deep mwl-calendar-month-view,
::ng-deep mwl-calendar-week-view,
::ng-deep mwl-calendar-day-view {
  border-radius: 10px;
}
@media (max-width: 768px) {
  .calendar-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
.view-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  background: #fff;
  border-radius: 12px;
  padding: 10px 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.view-title mat-icon {
  color: #d48f00;
}
::ng-deep .cal-event {
  display: flex;
  align-items: center;
  border: 1px solid !important;
  border-left: 5px solid !important;
  border-radius: 8px !important;
  padding: 6px 10px !important;
  margin-bottom: 4px !important;
  color: #2b2b2b !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 0.85;
}
::ng-deep .cal-event:hover {
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  opacity: 1;
}
::ng-deep .cal-event-title {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
::ng-deep .cal-day-cell.cal-today {
  background: #fffaf3 !important;
  border: 2px solid #d48f00 !important;
  border-radius: 10px;
}
::ng-deep .custom-event {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  line-height: 1.2;
}
::ng-deep .custom-event .event-title {
  font-weight: 600;
  color: #2d2d2d;
}
::ng-deep .custom-event .event-desc {
  color: #555;
  font-size: 12px;
  opacity: 0.9;
}
::ng-deep .custom-month-event,
::ng-deep .cal-event {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid !important;
  border-left: 5px solid !important;
  border-radius: 8px !important;
  padding: 4px 8px !important;
  margin-bottom: 4px !important;
  color: #2b2b2b !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease-in-out;
  overflow: hidden;
  opacity: 0.85;
}
::ng-deep .custom-month-event:hover,
::ng-deep .cal-event:hover {
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  opacity: 1;
}
::ng-deep .custom-month-event .contact,
::ng-deep .cal-event .contact {
  font-weight: 600;
  font-size: 13px;
  color: #1f1f1f;
  margin-bottom: 2px;
}
::ng-deep .custom-month-event .title,
::ng-deep .cal-event .title {
  font-size: 12px;
  color: #444;
  opacity: 0.9;
}
::ng-deep .cal-week-view .cal-event,
::ng-deep .cal-day-view .cal-event {
  border-radius: 8px !important;
  padding: 6px 8px !important;
  font-size: 12px !important;
  white-space: normal !important;
  line-height: 1.2 !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
::ng-deep .cal-day-cell.cal-today {
  background: #fffaf3 !important;
  border: 2px solid #d48f00 !important;
  border-radius: 10px;
}
::ng-deep .custom-event {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  border: 1px solid !important;
  border-left: 5px solid !important;
  border-radius: 8px !important;
  padding: 6px 10px !important;
  margin-bottom: 4px !important;
  color: #2b2b2b !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease-in-out;
}
::ng-deep .custom-event::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0);
  border-radius: 8px;
  transition: background 0.15s ease-in-out;
  pointer-events: none;
}
::ng-deep .custom-event:hover {
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
::ng-deep .custom-event:hover::before {
  background: rgba(0, 0, 0, 0.3);
}
::ng-deep .custom-event .contact {
  font-weight: 600;
  font-size: 13px;
  color: inherit;
  margin-bottom: 2px;
  position: relative;
  z-index: 1;
}
::ng-deep .custom-event .title {
  font-size: 12px;
  color: inherit;
  opacity: 0.9;
  position: relative;
  z-index: 1;
}
.month-events-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.month-mini-event {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-left: 4px solid #d48f00;
  border-radius: 7px;
  padding: 4px 6px;
  background: rgba(212, 143, 0, 0.12);
  text-align: left;
  cursor: pointer;
}
.month-mini-event-time {
  font-size: 11px;
  font-weight: 700;
  color: #374151;
  flex-shrink: 0;
}
.month-mini-event-contact {
  font-size: 12px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.month-more-events {
  border: none;
  background: transparent;
  color: #d48f00;
  font-size: 11px;
  font-weight: 700;
  text-align: left;
  padding: 0 2px;
  cursor: pointer;
}
.month-more-events:hover {
  text-decoration: underline;
}
.month-hidden-events-panel {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px dashed #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.month-mini-event-hidden {
  opacity: 0.95;
}
.booksy-day-view {
  border: 1px solid #e8edf3;
  border-radius: 14px;
  overflow: auto;
  max-height: 72vh;
  background:
    linear-gradient(
      180deg,
      #ffffff 0%,
      #fbfcfe 100%);
}
.booksy-day-header {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  align-items: stretch;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid #e8edf3;
}
.booksy-time-corner {
  position: sticky;
  left: 0;
  z-index: 35;
  min-width: 76px;
  width: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: #ffffff;
  border-right: 1px solid #edf2f7;
  padding: 1rem 0.75rem;
}
.booksy-employee-headers {
  display: flex;
  align-items: stretch;
  min-height: 72px;
}
.booksy-employee-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  border-right: 1px solid #edf2f7;
  background: #ffffff;
}
.booksy-employee-avatar {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 6px 18px rgba(17, 24, 39, 0.12);
}
.booksy-employee-avatar-fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(
      135deg,
      #d48f00 0%,
      #f0b840 100%);
  color: #ffffff;
  font-size: 0.85rem;
  font-weight: 700;
}
.booksy-employee-text {
  min-width: 0;
}
.booksy-employee-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.booksy-employee-subtitle {
  font-size: 0.76rem;
  color: #6b7280;
}
.booksy-day-body {
  display: flex;
  align-items: flex-start;
  position: relative;
}
.booksy-time-column {
  position: sticky;
  left: 0;
  z-index: 25;
  min-width: 76px;
  width: 76px;
  height: 100%;
  background: #ffffff;
  border-right: 1px solid #edf2f7;
}
.booksy-time-label {
  position: absolute;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
  padding-right: 0.9rem;
  text-align: right;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
}
.booksy-columns-wrapper {
  position: relative;
  display: flex;
  align-items: flex-start;
}
.booksy-grid-lines {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
}
.booksy-grid-line {
  position: absolute;
  left: 0;
  right: 0;
  border-top: 1px solid #dfe7f1;
}
.booksy-grid-line-half {
  border-top-style: dashed;
  border-top-color: #edf2f7;
}
.booksy-current-time-line {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 6;
  border-top: 2px solid #ef4444;
  pointer-events: none;
}
.booksy-current-time-dot {
  position: absolute;
  left: -6px;
  top: -7px;
  width: 12px;
  height: 12px;
  border-radius: 999px;
  background: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.18);
}
.booksy-employee-column {
  position: relative;
  z-index: 2;
  border-right: 1px solid #edf2f7;
  background:
    linear-gradient(
      180deg,
      rgba(249, 250, 251, 0.65) 0%,
      rgba(255, 255, 255, 0.9) 100%);
  cursor: cell;
}
.booksy-employee-column:hover {
  background:
    linear-gradient(
      180deg,
      rgba(255, 247, 237, 0.85) 0%,
      rgba(255, 255, 255, 1) 100%);
}
.booksy-day-event {
  position: absolute;
  left: 10px;
  right: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
  padding: 0.7rem 0.8rem;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-left-width: 4px;
  border-left-style: solid;
  border-radius: 12px;
  color: #fff !important;
  text-align: left;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);
  cursor: grab;
  overflow: hidden;
  min-height: 56px;
  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease,
    filter 0.18s ease;
  -webkit-user-select: none;
  user-select: none;
  touch-action: none;
}
.booksy-day-event:hover,
.booksy-day-event:focus-visible {
  transform: translateY(-1px);
  box-shadow: 0 16px 30px rgba(15, 23, 42, 0.14);
  filter: saturate(1.05);
  outline: none;
}
.booksy-day-event--dragging {
  cursor: grabbing;
  opacity: 0.85;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.25);
  transition: none;
  z-index: 10;
}
.booksy-day-event-resize-handle {
  position: absolute;
  left: 0;
  right: 0;
  height: 8px;
  cursor: ns-resize;
  z-index: 2;
  touch-action: none;
}
.booksy-day-event-resize-handle--top {
  top: 0;
}
.booksy-day-event-resize-handle--bottom {
  bottom: 0;
}
.booksy-day-event-resize-handle::after {
  content: "";
  display: block;
  width: 28px;
  height: 3px;
  margin: 2px auto 0;
  background: rgba(255, 255, 255, 0.65);
  border-radius: 2px;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.booksy-day-event:hover .booksy-day-event-resize-handle::after {
  opacity: 1;
}
@media (pointer: coarse) {
  .booksy-day-event-resize-handle {
    height: 22px;
  }
  .booksy-day-event-resize-handle::after {
    opacity: 0.85;
    height: 4px;
    width: 36px;
  }
  .booksy-day-event {
    min-height: 72px;
  }
}
.booksy-day-event-time {
  font-size: 0.72rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.85) !important;
}
.booksy-day-event-contact {
  font-size: 0.82rem;
  font-weight: 700;
  color: #fff !important;
}
.booksy-day-event-title {
  font-size: 0.76rem;
  color: rgba(255, 255, 255, 0.92) !important;
  line-height: 1.35;
  display: block;
}
.booksy-empty-header,
.booksy-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 240px;
  color: #6b7280;
  font-weight: 600;
}
.booksy-empty-header {
  min-height: 72px;
  padding: 0 1rem;
}
.booksy-empty-state {
  min-height: 240px;
  background:
    repeating-linear-gradient(
      180deg,
      rgba(248, 250, 252, 0.95) 0,
      rgba(248, 250, 252, 0.95) 59px,
      rgba(226, 232, 240, 0.6) 60px);
}
@media (max-width: 900px) {
  .booksy-day-view {
    max-height: 68vh;
  }
  .booksy-employee-header {
    min-width: 220px !important;
  }
  .booksy-employee-column {
    min-width: 220px !important;
  }
}
.booksy-week-view {
  border: 1px solid #e8edf3;
  border-radius: 14px;
  overflow: auto;
  max-height: 72vh;
  background: #ffffff;
}
.booksy-week-header {
  display: flex;
  position: sticky;
  top: 0;
  z-index: 20;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(8px);
  border-bottom: 2px solid #e8edf3;
}
.booksy-week-employee-corner {
  flex-shrink: 0;
  width: 180px;
  min-width: 180px;
  position: sticky;
  left: 0;
  z-index: 25;
  background: #ffffff;
  border-right: 1px solid #e8edf3;
}
.booksy-week-day-header {
  flex: 1 1 0;
  min-width: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.7rem 0.4rem;
  border-right: 1px solid #edf2f7;
  gap: 0.2rem;
}
.booksy-week-day-today {
  background: #fff8f0;
}
.booksy-week-day-name {
  font-size: 0.68rem;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.08em;
}
.booksy-week-day-num {
  font-size: 1.2rem;
  font-weight: 700;
  color: #111827;
  line-height: 1;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
}
.booksy-day-num-today {
  background: #d48f00;
  color: #ffffff;
}
.booksy-week-body {
  display: flex;
  flex-direction: column;
}
.booksy-week-row {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid #edf2f7;
  min-height: 80px;
}
.booksy-week-row:last-child {
  border-bottom: none;
}
.booksy-week-employee-cell {
  flex-shrink: 0;
  width: 180px;
  min-width: 180px;
  position: sticky;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.75rem 0.9rem;
  background: #ffffff;
  border-right: 1px solid #e8edf3;
}
.booksy-week-avatar {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(17, 24, 39, 0.1);
}
.booksy-week-avatar-fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(
      135deg,
      #d48f00 0%,
      #f0b840 100%);
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
}
.booksy-week-employee-name {
  font-size: 0.85rem;
  font-weight: 700;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.booksy-week-day-cell {
  flex: 1 1 0;
  min-width: 110px;
  padding: 0.45rem 0.4rem;
  border-right: 1px solid #edf2f7;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  cursor: pointer;
  transition: background 0.15s;
}
.booksy-week-day-cell:hover {
  background: #fafbfc;
}
.booksy-week-day-cell-today {
  background: #fffdf9;
}
.booksy-week-day-cell-today:hover {
  background: #fff5e6;
}
.booksy-week-event-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  width: 100%;
  padding: 0.3rem 0.45rem;
  border: none;
  border-left: 3px solid;
  border-radius: 7px;
  cursor: grab;
  text-align: left;
  color: #fff !important;
  transition: filter 0.15s, transform 0.1s;
  -webkit-user-select: none;
  user-select: none;
  touch-action: none;
}
.booksy-week-event-card:hover {
  filter: brightness(0.96);
  transform: scale(1.01);
}
.booksy-week-event-card--dragging {
  opacity: 0.55;
  cursor: grabbing;
}
.booksy-week-day-cell-drop-target {
  background: rgba(212, 143, 0, 0.12);
  outline: 2px dashed rgba(212, 143, 0, 0.55);
  outline-offset: -2px;
}
.booksy-week-event-time {
  font-size: 0.68rem;
  font-weight: 700;
  color: #fff !important;
  line-height: 1.2;
}
.booksy-week-event-contact {
  font-size: 0.75rem;
  font-weight: 600;
  color: #fff !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.booksy-week-add-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 300;
  color: #d1d5db;
  margin: auto;
  transition: color 0.15s, background 0.15s;
}
.booksy-week-day-cell:hover .booksy-week-add-hint {
  color: #d48f00;
  background: rgba(212, 143, 0, 0.1);
}
.booksy-week-no-employees {
  padding: 3rem 1rem;
  text-align: center;
  font-weight: 600;
  color: #6b7280;
}
@media (max-width: 900px) {
  .booksy-week-employee-cell,
  .booksy-week-employee-corner {
    width: 110px;
    min-width: 110px;
  }
  .booksy-week-day-cell {
    min-width: 80px;
  }
}
.booksy-drag-ghost {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0.45rem 0.6rem;
  border-left: 4px solid;
  border-radius: 9px;
  color: #fff;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.35);
  transform: rotate(-2deg);
  opacity: 0.96;
  max-width: 280px;
  overflow: hidden;
  will-change: left, top;
}
.booksy-drag-ghost-time {
  font-size: 0.7rem;
  font-weight: 700;
  color: #fff;
  line-height: 1.15;
}
.booksy-drag-ghost-contact {
  font-size: 0.78rem;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.booksy-dragging-active,
.booksy-dragging-active * {
  cursor: grabbing !important;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.modal {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: auto;
  max-width: 500px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  overflow-y: auto;
  max-height: 90vh;
  z-index: 2001;
  animation: fadeIn 0.3s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.modal h2 {
  margin-top: 0;
  font-size: 20px;
  color: #333;
}
.modal form label {
  display: block;
  margin-top: 10px;
  font-weight: bold;
  color: #444;
}
.modal form input,
.modal form textarea,
.modal form select {
  width: 100%;
  padding: 8px;
  margin-top: 4px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.modal-buttons {
  margin-top: 20px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.modal-buttons button {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}
.modal-buttons button[type=submit] {
  background-color: #e3fd64;
  color: #1a1d23;
}
.modal-buttons button[type=button] {
  background-color: #ccc;
  color: #333;
}
@media (max-width: 768px) {
  .calendar-main {
    width: 95vw;
    height: 90vh;
    padding: 10px;
  }
  #calendar {
    padding: 0;
    height: 100%;
  }
  .btn-nuevo-evento {
    font-size: 14px;
    padding: 8px 12px;
  }
  .modal {
    max-width: 100%;
    padding: 15px;
  }
  .modal-buttons {
    flex-direction: column;
    gap: 8px;
  }
  .modal-buttons button {
    width: 100%;
  }
}
.event-form {
  display: flex;
  flex-direction: column;
}
.full-width {
  width: 100%;
  margin-bottom: 1rem;
}
.date-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
.half-width {
  flex: 1 1 45%;
  min-width: 200px;
}
mat-dialog-actions {
  margin-top: 1.5rem;
}
.row-fields {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.half-width {
  flex: 1 1 0;
  min-width: 200px;
}
/*# sourceMappingURL=booking-calendar.component.css.map */
